import { useContext, useEffect } from 'react';
import { MobXProviderContext } from 'mobx-react';

import { AppStore } from '@kaltura-ott/tvpil-shared';

function useAppLangAttributeManager(){
  const {
    appStore: { localizationStore },
  } = useContext(MobXProviderContext) as {
    appStore: AppStore;
  };

  useEffect(() => {
    const { displayLanguage } = localizationStore;

    if (displayLanguage) {
      document.documentElement.setAttribute('lang', localizationStore.displayLanguage);
    }

  }, [localizationStore.displayLanguage]);
};

export { useAppLangAttributeManager };
